import { types, Instance, SnapshotIn, SnapshotOut } from 'mobx-state-tree';
import { modelWithCRUD } from './utils/modelWithCRUD';

export const BankDetails = types.model({
  id: types.union(types.identifierNumber, types.identifier),
  currency: types.string,
  iban: types.string,
  bic: types.string,
});

export const BankDetailsStore = modelWithCRUD(
  'bank-details',
  BankDetails
).named('BankDetailsStore');

export interface IBankDetails extends Instance<typeof BankDetails> {}
export interface IBankDetailsSnapshotIn
  extends SnapshotIn<typeof BankDetails> {}
export interface IBankDetailsSnapshotOut
  extends SnapshotOut<typeof BankDetails> {}
